import React, { Component, useState } from 'react'
import { Select, Row, Col, Space, Input, Button, DatePicker, message } from 'antd'
import Title from 'antd/lib/typography/Title';
import t from '../i18n';
import TextArea from 'antd/lib/input/TextArea';
const { Option } = Select;


const AccountRow = (props) => {
  const { accounts, account, onChangeAccount, onChangeAmount } = props

  const [selected, setselected] = useState(false)

  const accountSelectedHandler = value => {
    setselected(true);
    onChangeAccount(value)
  }
  
  return(
    // <Row>
    //   <Col span={24}>
    <Space style={{margin: '5px'}}>
    <Select
      showSearch
      style={{ minWidth: 300 }}
      placeholder="Select an account"
      optionFilterProp="children"
      onChange={accountSelectedHandler}
    >
      {accounts.map((account, index) =>  <Option key={index} value={account.id}>{account.name}</Option>) }
    </Select>
      <Input placeholder="Amount" disabled={!selected}  onChange={(e) => onChangeAmount(e.target.value)}/>
    </Space>

    //   </Col>
    // </Row>
  )
  
}


export class OpeningBalance extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       assetAccounts: props.assets,
      liabilityAccounts: props.liabilities,
       liabilities: [
         {account: null, amount: ''}
       ],
        assets: [
          { account: null, amount: '' }
        ]
    }
  }

  addAssetRow = (params) => {
    const { assets } = this.state
    assets.push({ account: null, amount: '' })
    this.setState({assets})
  }

  addLiabilitiesRow = (params) => {
    const { liabilities } = this.state
    liabilities.push({ account: null, amount: '' });
    this.setState({ liabilities })
  }
  
  assetChanged = (index, column, value) => {
    const { assets } = this.state
    assets[index][column] = value
    const assetsTotal = assets.reduce((total, account) => total + safeNumber( account.amount), 0.0)

    this.setState({ assets, assetsTotal })
    
  }
  liabilityChanged = (index, column, value) => {
    const { liabilities } = this.state;
    liabilities[index][column] = value;
    const liabilitiesTotal = liabilities.reduce((total, account) => total + safeNumber(account.amount), 0.0)

    this.setState({ liabilities, liabilitiesTotal });

  }

  readyToSave = (params) => {
    const { liabilitiesTotal, assetsTotal } = this.state
    return assetsTotal > 0 && (safeNumber( assetsTotal) == safeNumber(liabilitiesTotal))

  }
  
  submitOpeningBalance = (params) => {

    const { assets, liabilities, date, comments } = this.state
    if(!date) {message.error(t('date_missing')); return;}
    const $this = this;
    this.setState({ saving: true });

    $.ajax({
      type: "POST",
      dataType: 'json',
      url: ' /accounting/chart_of_accounts/opening_balance',
      data: {
        assets, liabilities, date, comments, token: Spree.api_key
      },
      success: function () {
        message.info("Opening balance saved")
        $this.setState({ assets: [], liabilities: [], date: null, comments: null})
      },
      error: function (response, textStatus, errorThrown) {

        message.error(response.responseText);
        $this.setState({ saving: false });
      },
    }).done(function (done) {

      $this.setState({ saving: false });

    });
  }
  
  
  render() {
    const { assets, liabilities, assetAccounts, liabilityAccounts, 
      assetsTotal, liabilitiesTotal, saving } = this.state

    return (
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            Enter Opening Balance
          </div>
        </div>
        <div className="card-block">
          <Row>
            <Col span={12} style={{ borderBottom: 'lightgray 1px solid', marginBottom: '10px', paddingBottom: '10px'  }}>
              <Title>Assets</Title>

                {
                  assets.map((account, index) =>
                    <Row key={index}> 
                      <Space> 
                        <Col span={24}>
                          <AccountRow 
                            accounts={assetAccounts} 
                            account={account} 
                            type="assets" 
                            onChangeAmount={ (value) => this.assetChanged(index, 'amount', value)}
                            onChangeAccount={ (value) => this.assetChanged(index, 'account', value)}
                          /> 
                        </Col> 
                      </Space>
                      </Row> 
                  )   
                }
                <br />
                <Button onClick={this.addAssetRow}>Add Row</Button>
              <label style={{ display: 'inline-table', marginLeft: '150px' }}>Total: {assetsTotal}</label>

            </Col>
            <Col span={12} style={{ borderBottom: 'lightgray 1px solid', marginBottom: '10px', paddingBottom: '10px'}}>
              <Title>Liabilities & Equity</Title>

              {
                liabilities.map((account, index) =>
                  <Row key={index}>
                    <Space>
                      <Col span={24}>
                        <AccountRow 
                          accounts={liabilityAccounts} 
                          account={account} 
                          type="liabilities" 
                          onChangeAmount={(value) => this.liabilityChanged(index, 'amount', value)}
                          onChangeAccount={(value) => this.liabilityChanged(index, 'account', value)}
                        />
                      </Col>
                    </Space>
                  </Row>
                )
              }
              <br />
              <Space>
              <Button onClick={this.addLiabilitiesRow}>Add Row</Button>

              <label style={{display: 'inline-table', marginLeft: '150px'}}>Total: {liabilitiesTotal}</label>
              </Space>
            </Col>

          </Row>
          <Row  style={{marginTop: '20px'}}>
     
            <Col span={16}>
            <Space>
                {t('date')} <DatePicker onChange={(date) => this.setState({ date: date.format('ll')  })} />
         

                {t('comments')} <TextArea onChange={(e) => this.setState({comments: e.target.value})} />
              </Space>
            </Col>
            <Col span={6}>
              <Button
                loading={saving}
                size="large"
                type="primary"
                disabled={!this.readyToSave()}
                onClick={this.submitOpeningBalance}
              >
                Save Opening Balance
              </Button>
            </Col>
          </Row>
        </div>
      </div>

    )
  }
}

export default OpeningBalance
